module.exports = __webpack_public_path__ + "public/img/name-white.58676c6e.svg";